import React from "react";
import { Route } from "react-router-dom";
import lazyWithRetry from "helpers/lazyWithRetry";

const IndexReservationsPage = lazyWithRetry(() =>
  import("./IndexReservationsPage")
);

export default [
  <Route
    exact
    path="/reservations"
    key="reservations-index"
    component={IndexReservationsPage}
  />,
];
